// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"254":"5c3c9b9cff9a0dc93991","405":"dfa9d639b06a30a85b9e","888":"b98f54a4b65dc64c407b"}[chunkId] + ".css";
};